// https://github.com/kenwheeler/slick

import $ from "jquery";
import "slick-carousel/slick/slick";
import "slick-carousel/slick/slick.css";

/****** SLIDERS *******/
const sliders = {
	home: $(".team-members-slider-container .inner"),
	trustedBy: $(".trusted-by-slider"),
};

sliders.home.slick({
	appendArrows: $(".team-members-slider-container nav"),
	autoplay: true,
	dots: false,
	fade: true,
	nextArrow: "<a href='#0' class='next'>next</a>",
	prevArrow: "<a href='#0' class='prev'>prev</a>",
});
